import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiRequestError } from './client.js';

export function createDashboardQueryClient(onUnauthorized: () => void): QueryClient {
  const handleError = (error: unknown): void => {
    if (error instanceof ApiRequestError && error.code === 'unauthorized') onUnauthorized();
  };

  return new QueryClient({
    queryCache: new QueryCache({ onError: handleError }),
    mutationCache: new MutationCache({ onError: handleError }),
    defaultOptions: {
      queries: {
        staleTime: 0,
        gcTime: 5 * 60 * 1000,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
      },
    },
  });
}
